var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-link-list',{class:_vm.$style.wrap,attrs:{"list":_vm.links}})}
var staticRenderFns = []

export { render, staticRenderFns }